import { apiGET } from './api';

export const getChatToken = () => apiGET('/chat/token');
